<flx-resources-grid
  [tableDef]="triggerTableColumns"
  [items]="rowData()"
  emptyMsg="No trigger found."
/>
